export enum WEB_SOCKET_NOTIFICATION_TYPES {
	'INCORRECT_CONTACT' = 'INCORRECT_CONTACT',
	'RFP' = 'RFP',
}
